import type {
  AdminUserAnalyticsData,
  LoginResponse
} from '@bo-types/authentication';
import type { AnalyticsPageViewKey } from '@bo-types/analytics';
import { omit } from 'ramda';

export const getAdminUserAnalyticDetails = (
  userData: LoginResponse
): AdminUserAnalyticsData => {
  const {
    data: { attributes, id }
  } = userData;

  const cleanedAttributes = omit(
    ['created_at', 'permissions', 'roles', 'updated_at'],
    attributes
  );

  return {
    ...cleanedAttributes,
    id,
    roles: attributes.roles.map((role) => role.name)
  };
};

export const getPageViewName = (
  pageViewKey: AnalyticsPageViewKey,
  pathname: string
) => {
  const foundEntry = Object.entries(pageViewKey).find(([key]) =>
    pathname.includes(key.toLowerCase().replace(/_/g, '-'))
  );

  if (foundEntry) {
    return foundEntry[1];
  }

  return pageViewKey?.PARENT_VIEW || undefined;
};
